"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var INTERPOLATE_PATTERN = /{{([\s\S]+?)}}/gi;
function interpolate(translation, values) {
    return translation.replace(INTERPOLATE_PATTERN, function (matched, valueKey) {
        return typeof values[valueKey] !== 'undefined'
            ? String(values[valueKey])
            : matched;
    });
}
function createI18nClient(i18n) {
    return {
        get locale() {
            return i18n.locale;
        },
        get language() {
            return i18n.language;
        },
        translate: function (key, values) {
            var translation = i18n.translations[key];
            if (!translation) {
                return "[".concat(key, "]");
            }
            return values ? interpolate(translation, values) : translation;
        },
    };
}
exports.default = createI18nClient;
//# sourceMappingURL=createI18nClient.js.map